(() => {
  const element = document.getElementById('mc-ivory-map');
  if (!element) return;
  const map = JSON.parse(element.textContent);
  function match(url) {
    if (!url) return;
    const name = url.split('?')[0].split('/').pop();
    return map[name] || map[name.replace(/_\d+x\d*(?=\.[^.]+$)/, '')];
  }
  function update(img) {
    if (!img.matches?.('img, source')) return;
    const replacement = match(img.getAttribute('src')) || match((img.getAttribute('srcset') || '').split(/\s/)[0]);
    if (!replacement) return;
    if (img.tagName === 'IMG') img.setAttribute('src', replacement.src);
    img.setAttribute('srcset', replacement.srcset);
    if (img.tagName === 'SOURCE' && img.hasAttribute('type')) img.setAttribute('type', 'image/webp');
  }
  function scan(root) { update(root); root.querySelectorAll?.('img,source').forEach(update); }
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') update(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset']});
})();

/* Mamacita: on phones, show the sticky bar from the first screen.
   Before the shopper reaches the size picker it reads "Choose your size · £xx" and scrolls to the picker;
   once they've passed the buy box, the theme's normal sticky "Add to cart" takes over. */
(() => {
  const mq = window.matchMedia('(max-width: 699px)');
  const init = () => {
    const bar = document.querySelector('product-sticky-bar');
    if (!bar || bar.querySelector('.mc-sticky-choose')) return;
    const formId = bar.getAttribute('form');
    const form = document.forms[formId];
    if (!form) return;
    const radio = document.querySelector('input[type="radio"][form="' + formId + '"]');
    const picker = radio ? radio.closest('variant-picker') || radio.closest('fieldset') : null;
    const target = picker || form;
    const price = (bar.querySelector('sale-price')?.textContent || '').replace(/sale price/i, '').trim();

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button mc-sticky-choose';
    button.textContent = (picker ? 'Choose your size' : 'Add to cart') + (price ? ' · ' + price : '');
    button.addEventListener('click', () => {
      if (picker) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
    bar.appendChild(button);

    let targetBelow = false;
    let footerVisible = false;
    const update = () => bar.classList.toggle('mc-early', mq.matches && targetBelow && !footerVisible);
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => { targetBelow = !entry.isIntersecting && entry.boundingClientRect.top > 0; });
      update();
    }).observe(target);
    const footer = document.querySelector('.shopify-section--footer');
    if (footer) new IntersectionObserver((entries) => { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    mq.addEventListener?.('change', update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
